module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "epub:type": "prologue",
      "id": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("The lace curtain gently flapped.")]), _vm._v(" Heated night-time air wafted in through the gap of the partially opened balcony doors, swirling with the cooler air-conditioned interior. Beyond the glass, luxury yachts lined up next to one another on the marina below, gently bobbing. Apartment buildings rose up around the crafts, all clustered around the water. Many windows were dark, but in others, soft lights shone. TVs flickered. Tiny shadowy figures moved about in their private spaces. Few bothered to cover their windows on such a balmy evening. Some people stood or sat in their kitchens, cooking or eating. Some lounged on sofas. Others partied out on balconies, or in rooftop gardens for the lucky few who could afford the ultra-expensive penthouses.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Lights on, curtains open in bedrooms too. A couple directly across the way, three floors down, stood at the edge of a bed. Naked? The low light, the distance, without binoculars, made it hard to tell. The woman slid down to her knees in front of her lover. The man cocked his head toward the window, looking out. A sudden pang of shyness? Or hoping to see people-watching?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A stronger gust of salty sea air caused the curtain to snap like a whip. In the room behind a piece of paper lifted from the dining table and flapped to the floor where broken glasses, plates, torn cushions lay. Much of the debris was speckled with red dots, larger smears here and there. So too the plush leather sofa, the funky, colourful art on the walls, the white walls themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But the largest pool of red by far was the one edging out of the open door to the master bedroom. It hadn’t been like that before. In only a couple of minutes the blood had flowed and moved beyond the threshold, as though seeking escape, or attempting to fight back, or desperately searching for help.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("It would achieve none of those aims.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The source of the blood lay crumpled by the edge of the bed. Glassy eyes stared to the doorway from a body near naked, except for the ruined white underwear. Calvin Klein. Pricey, but not extravagant. Comfortable, rather than overtly sexy or showy. Very "), _c('i', [_vm._v("her")]), _vm._v(" really. Her twisted limbs glistened, the silky skin on her body now forever tarnished.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The dark-clothed figure moved up to her, being careful not to step in the still growing pool of red.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sorry.’ The words weren’t heartfelt. Should they have been? ‘I"), _c('i', [_vm._v(" am")]), _vm._v(" sorry. It shouldn’t have ended like this.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("But of course "), _c('i', [_vm._v("she ")]), _vm._v("said nothing in return. If she could have spoken, what would her response have been?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The figure straightened up, sighed, took in one last look of her, then slowly, silently turned, and headed out into the night.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c1691e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0